var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPhone(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 20,
    viewBox: "0 0 14 20",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.36291 0.438987L3.4395 0.09498C4.44832 -0.227371 5.52617 0.293579 5.95819 1.31232L6.81793 3.33967C7.19258 4.22312 6.98468 5.26203 6.30395 5.90815L4.40963 7.70616C4.52651 8.78164 4.88802 9.84064 5.49416 10.8832C6.1003 11.9257 6.85732 12.7905 7.76522 13.4776L10.0404 12.7189C10.9028 12.4313 11.842 12.7618 12.371 13.539L13.6034 15.3495C14.2183 16.2529 14.1077 17.4993 13.3447 18.2653L12.527 19.0862C11.713 19.9033 10.5505 20.1997 9.47508 19.8643C6.93623 19.0723 4.60191 16.7211 2.47214 12.8107C0.339269 8.89448 -0.41348 5.57189 0.213892 2.84289C0.477888 1.69457 1.2954 0.780091 2.36291 0.438987Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhone);
export default __webpack_public_path__ + "static/media/phone.0aaf52be2563ba6b7fc4879e2d7c4f95.svg";
export { ForwardRef as ReactComponent };